import {Component, OnDestroy, OnInit} from "@angular/core";
import {WorkflowStep} from "../workflow-step";
import {ActivatedRoute, Router} from "@angular/router";
import {WorkflowService} from "../workflow.service";
import {WorkflowTargetInfoModel} from "../models/workflow-target-info.model";
import {CustomerService} from "../../customer/customer-service";
import {SiteNameStructureModel} from "./site-name-structure.model";
import {ProjectService} from "../../project/project.service";
import {handleErrors} from "../../misc/handle-errors.decorator";
import {toggleLoading} from "../../misc/loading.decorator";

@Component({
  templateUrl: "site-name-structure.template.pug",
  providers: [CustomerService, ProjectService],
})
export class SiteNameStructureComponent extends WorkflowStep implements OnInit, OnDestroy {
  error: Error;
  projectId: string;
  siteNameStructureForm: SiteNameStructureModel = new SiteNameStructureModel();
  isMigrationActive: boolean = false;

  @toggleLoading()
  @handleErrors()
  async loadProject(projectId: string): Promise<void> {
    this.projectId = projectId;
    const project = await this.projectService.getProjectById(projectId).toPromise();
    this.isMigrationActive = project.isMigrationActive;
    this.siteNameStructureForm.parseProjectJson(project);
  }

  async ready(workflowTargetInfo: WorkflowTargetInfoModel) {
    await this.loadProject(workflowTargetInfo.projectId);
  }

  @handleErrors()
  async autoSave(): Promise<boolean> {
    await this.projectService.saveSiteNameStructure(
      this.projectId,
      this.siteNameStructureForm.getRawValue().siteNameStructure,
    );

    return true;
  }

  checkDirty(): boolean {
    return this.siteNameStructureForm.dirty;
  }

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public workflowService: WorkflowService,
    private projectService: ProjectService,
  ) {
    super();
  }
}
